<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li> 
                        <li>News</li>
                    </ul>
                </div>
            </section>
            <div class="mission_banner_wrapper custom-banner-section">
                <div class="about_main_image">
                    <img src="https://testuc222.sirv.com/Images/NAMA/news.png" alt="news" />
                    <div class="about_main_title">
                        <h4>News</h4>
                    </div>
                </div>
                <div class="news_slider_wrapper"  v-if="news_listing!=null && news_listing.data.length">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <slick ref="slick" :options="slickOptions1"  class="banner-slider stick-dots slider-for" >
                                    <div class="news_slider_content"  v-for="news in news_listing.data">
                                        <img :src="hostname+'/admin/images/news_images/'+news.image">
                                        <span>{{  format_date(news.created_at) }}</span>
                                        <p>{{ news.title_eng }}</p>
                                        <a class="nav-link" :href="news.link" target="_blank">Read more</a>
                                    </div>
                                    <div class="news_slider_content"  v-for="news in news_listing.data">
                                        <img :src="hostname+'/admin/images/news_images/'+news.image">
                                        <span>{{  format_date(news.created_at) }}</span>
                                        <p>{{ news.title_eng }}</p>
                                        <a class="nav-link" :href="news.link" target="_blank">Read more</a>
                                    </div>
                                </slick>
                                <slick ref="slick" :options="slickOptions2"  class="banner-slider stick-dots slider-nav" >
                                    <div class="news_slider_content"  v-for="news in news_listing.data">
                                        <img :src="hostname+'/admin/images/news_images/'+news.image">
                                    </div>
                                    <div class="news_slider_content"  v-for="news in news_listing.data">
                                        <img :src="hostname+'/admin/images/news_images/'+news.image">
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>

import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';

import HeaderMenu from '../HeaderMenu'
import router from '../../router'
import EventBus from '../EventBus'
import Pagination from "../Pagination"
import NewsSidebar from "./NewsSidebar"

export default{
    data(){
        this.get_page_content();
        return {
            slickOptions1: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slider-nav'
            },
            slickOptions2: {
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                dots: false,
                arrows: true,
                prevArrow: '<div class="slick-prev"></div>',
                nextArrow: '<div class="slick-next"></div>',
                focusOnSelect: true,
                responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 4
                      }
                    }
                ]
            },
            news_listing:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale,
            search_slug:false
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        Pagination:Pagination,
        NewsSidebar:NewsSidebar,
        Slick
    },
    methods:{
        async get_page_content() {
        	
            var _self = this; 
            var page_num = (_self.news_listing==undefined) ? 1 :  _self.news_listing.current_page;
            var query_args={};
            if(_self.search_slug){
            	query_args.search=_self.search_slug;
            }
            query_args.page=page_num
            await this.$axios_global.post(_self.$hostname+'/api/news-insights',query_args)
            .then((res) => {
                var response = res.data.data;
                _self.news_listing = response;
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        search_results(search_slug,page_num){
        	this.news_listing.current_page = page_num;
        	this.search_slug = search_slug;
        	this.get_page_content();	
        },
        format_date(value){
	        if (value) {
	           return this.$moment_global(String(value)).format('YYYY-MM-DD')
	        }
	    },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/News/NewsInsightsListing.vue